import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f497a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-container" }

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAlert',
  props: {
  variant: {
    type: String as PropType<"danger" | "info" | "success" | "announcement">,
    required: false,
    default: "info",
    validator: (value: string) =>
      ["danger", "info", "success", "annoucement"].includes(value),
  },
  dismissible: {
    type: Boolean,
    required: false,
    default: false,
  },
  large: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["dismissed"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`${
        __props.large ? 'larger' : 'medium'
      }-width-centered alert alert-${__props.variant}${
        __props.dismissible ? ' alert-dismissible' : ''
      }`),
      role: "alert"
    }, [
      (__props.variant === 'danger')
        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
            key: 0,
            icon: "fa-solid fa-circle-exclamation"
          }))
        : (__props.variant === 'success')
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 1,
              icon: "fa-solid fa-check"
            }))
          : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (__props.dismissible)
        ? (_openBlock(), _createBlock(_component_BaseButton, {
            key: 2,
            type: "button",
            "btn-style": "transparent",
            class: "alert-dismiss",
            "aria-label": "Dismiss message",
            icon: "xmark",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismissed')))
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})